<template>
    <div>
        <page-title-bar :class-container="$vuetify.breakpoint.smAndDown ? '' : 'pa-0'">
            <template slot="actions">
                <v-tooltip top>
                    <v-btn slot="activator" icon large @click="getFacturas">
                        <v-icon color="grey">ti ti-reload</v-icon>
                    </v-btn>
                    <span>Recargar Facturas</span>
                </v-tooltip>
            </template>
        </page-title-bar>
        <v-container fluid grid-list-xl :class="$vuetify.breakpoint.smAndDown ? 'pt-0' : 'pa-2'">
            <v-layout row wrap border-rad-sm overflow-hidden>
                <v-flex xs12>
                    <v-data-table
                            :headers="headers"
                            :items="facturas"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.consecutivo }}</td>
                            <td>{{ props.item.fecha }}</td>
                            <td>{{ props.item.estado }}</td>
                            <td class="text-xs-right">{{ currency(props.item.total) }}</td>
                            <td class="text-xs-right">{{ currency(props.item.abono) }}</td>
                            <td class="text-xs-right">{{ currency(props.item.saldo) }}</td>
<!--                            <td class="text-xs-center">-->
<!--                                <v-btn flat icon color="error" @click="verFactura(props.item.id)">-->
<!--                                    <v-icon>far fa-file-pdf</v-icon>-->
<!--                                </v-btn>-->
<!--                            </td>-->
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
        <app-section-loader :status="loader"></app-section-loader>
    </div>
</template>

<script>
    export default {
        name: 'Facturas',
        data: () => ({
            loader: false,
            facturas: [],
            headers: [
                {
                    text: 'Número',
                    sortable: false,
                    value: 'concecutivo'
                },
                {
                    text: 'Fecha',
                    sortable: false,
                    value: 'fecha'
                },
                {
                    text: 'Estado',
                    sortable: false,
                    value: 'estado'
                },
                {
                    text: 'Valor total',
                    sortable: false,
                    value: 'total',
                    align: 'right'
                },
                {
                    text: 'Abono',
                    sortable: false,
                    value: 'abono',
                    align: 'right'
                },
                {
                    text: 'Saldo',
                    sortable: false,
                    value: 'saldo',
                    align: 'right'
                }
                // {
                //     text: '',
                //     sortable: false,
                //     value: 'id',
                //     align: 'center'
                // }
            ]
        }),
        created () {
            this.getFacturas()
        },
        methods: {
            verFactura (facturaId) {
                this.loader = true
                this.axios.get(`host/facturas/getpdf/${facturaId}`)
                    .then(response => {
                        console.log('datos', response)
                        this.loader = false
                    }).catch(e => {
                    this.loader = false
                    this.$store.commit('snackbar', {color: 'error', message: `al recuperar la factura`, error: e})
                })
            },
            getFacturas () {
                this.loader = true
                this.axios.get(`cartera`)
                    .then(response => {
                        this.facturas = response.data.detalle
                        this.loader = false
                    }).catch(e => {
                    this.loader = false
                    this.$store.commit('snackbar', {color: 'error', message: `al recuperar las facturas`, error: e})
                })
            }
        }
    }
</script>

<style scoped>

</style>